import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddSiteComponent {
  constructor(
    private route: ActivatedRoute,
    private ToastService: ToastService
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const CompanyId = ParamMap.get('CompanyId');

        if (!CompanyId) {
          throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
            returnError: true
          });
        }

        this.CompanyId = Number(CompanyId);
      }
    });
  }

  CompanyId!: number;
}
